import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { FetchModels, ViewsModels } from '../types';

export function* fetchRelatedProducts(props: FetchModels.RequestProps, options: ApiRequestConfig) {
  const response = yield* get<FetchModels.ResponseData>('get-related-products', props, {
    ...options,
  });

  return response.data as ViewsModels.RelatedProducts;
}
